export default __webpack_public_path__ + "static/media/logo.a334e544.png";